import(/* webpackMode: "eager", webpackExports: ["SignInForm"] */ "/vercel/path0/apps/web/src/app/(auth)/sign-in/sign-in-form.tsx");
